import { render } from "./TraitShopSearch.vue?vue&type=template&id=4d81f4fa"
import script from "./TraitShopSearch.vue?vue&type=script&lang=js"
export * from "./TraitShopSearch.vue?vue&type=script&lang=js"

import "./TraitShopSearch.vue?vue&type=style&index=0&id=4d81f4fa&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__